import {GET_OFFICES_START} from "store/constants";

export const getOffices = () => ({
    type: GET_OFFICES_START,
    payload: null
});